import UUIDBase from '../UUIDBase'
import { useI18nInstance } from '@/plugins/i18n'
import User from '@/models/user/User'

const { t } = useI18nInstance().global

export const moneyCollectorCommissionI18nMessages = {
  en: {
    moneyCollectorCommissionInfo: 'Money Collector Commission Info',
    name: 'Name',
    stores: 'Store(s)',
    employees: 'Money Collectors',
    rules: 'Collection Rules',
    addRule: 'Add Rule',
    all: 'All',
    amount: 'Amount',
    percentage: 'Percentage',
    period: 'Period',
    open: 'Open',
    dateRange: 'Date Range',
    from: 'From',
    to: 'To',
    disabled: 'Disabled',
    user: 'Created By',
    fromDay: 'From Day',
    toDay: 'To Day',
    type: 'Type',
    commissionValue: 'Commission Value',
    days: 'Days',
    daysFromDueDate: 'Days from Due Date',
    collectionSpeed: 'Collection Speed'
  },
  ar: {
    moneyCollectorCommissionInfo: 'معلومات عمولة الجباة',
    name: 'الاسم',
    stores: 'المتجر',
    employees: 'الجباة المشمولون',
    rules: 'قواعد العمولة',
    addRule: 'اضافة قاعدة',
    all: 'الجميع',
    amount: 'مبلغ ثابت',
    percentage: 'نسبة مئوية',
    period: 'الفترة',
    open: 'مفتوح',
    dateRange: 'نطاق التاريخ',
    from: 'من',
    to: 'الى',
    disabled: 'معطل',
    user: 'تم إنشاؤه بواسطة',
    fromDay: 'من يوم',
    toDay: 'إلى يوم',
    type: 'النوع',
    commissionValue: 'قيمة العمولة',
    days: 'أيام',
    daysFromDueDate: 'أيام من تاريخ الاستحقاق',
    collectionSpeed: 'سرعة التحصيل'
  }
}

export class CollectionRule {
  fromDay = 0
  toDay = 0
  type = 'percentage' // 'amount' or 'percentage'
  amount = 0
  order = 0

  static from(json: Record<string, unknown> | CollectionRule) {
    return Object.assign(new CollectionRule(), json)
  }
}

export default class MoneyCollectorCommission extends UUIDBase {
  static ENDPOINT = '/hr/money-collector-commissions'

  name = ''
  stores?: Array<string>
  includeAllStores = false
  rules?: Array<CollectionRule>
  employees?: Array<string>
  includeAllEmployees = false
  period = 'open'
  fromDate?: string
  toDate?: string
  disabled = false
  userID = ''
  user?: User

  static from(json: Record<string, unknown> | MoneyCollectorCommission) {
    const commission = Object.assign(new MoneyCollectorCommission(), json)
    if (json.rules) {
      commission.rules = (json.rules as Array<any>).map((i) => CollectionRule.from(i))
    }

    if (json.user) commission.user = User.from(json.user as any)

    return commission
  }
}
